'use client';

import type {FC} from 'react';

import {Spinner} from '../_components/Spinner';

const Loading: FC = () => {
  return (
    <div className="center h-full min-h-[180px] w-full select-none">
      <Spinner />
    </div>
  );
};

export default Loading;
